export class YearCount {
    public value: number;
    public displayValue: string;

    public static list(years: number = 20): YearCount[] {
        let yearCounts: YearCount[] = [];

        for (var yr = 0; yr <= years; yr++) {
            if (yr == 0) {
                yearCounts.push({ value: yr, displayValue: "< 1 year" } as YearCount);
                continue;
            }

            yearCounts.push({ value: yr, displayValue: yr + " years" } as YearCount);

            if (yr == 20) {
                yearCounts.push({ value: yr + 1, displayValue: "> 20 years" } as YearCount);
            }
        }

        return yearCounts;
    }
}